import { onBeforeUnmount, onMounted, toValue, watch, type MaybeRefOrGetter } from 'vue';
import { lockPageScroll } from '~/utils/page-scroll-lock';

export function usePageScrollLock(active: MaybeRefOrGetter<boolean>): void {
  let release: (() => void) | undefined;
  let stop: (() => void) | undefined;

  onMounted(() => {
    stop = watch(
      () => toValue(active),
      (isActive) => {
        if (isActive && !release) release = lockPageScroll();
        else if (!isActive && release) {
          release();
          release = undefined;
        }
      },
      { immediate: true, flush: 'sync' }
    );
  });

  onBeforeUnmount(() => {
    stop?.();
    release?.();
  });
}
